import { t } from '@framework/i18n/intl/i18next.ts';
import { yup } from '@framework/validation/initYup.ts';
import { RuleType } from '../../IRule.ts';
import { type IRuleType } from '../../IRuleType.ts';
import { ItemRangeRuleComponent } from './ItemRangeRuleComponent.tsx';

const MAX_ITEMS = 50;

const configValidator = yup
  .object({
    min: yup
      .number()
      .notRequired()
      .max(MAX_ITEMS)
      .positive()
      .label('Minimo spunte'),
    max: yup
      .number()
      .notRequired()
      .greaterThan('min')
      .positive()
      .max(MAX_ITEMS)
      .label('Massimo spunte'),
    minCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
    maxCustomMessage: yup
      .string()
      .notRequired()
      .label('Messaggio personalizzato di validazione'),
  })
  .notRequired()
  .noUnknown()
  .nullable();

type IRuleItemRange = yup.InferType<typeof configValidator>;

export const ItemRangeRule: IRuleType<IRuleItemRange> = {
  type: RuleType.ItemRange,
  name: 'Valore massimo',
  configComponent: ItemRangeRuleComponent,
  configValidator,
  validator: (schema, rule) => {
    if (!rule) return schema;

    if (rule.min != null) {
      schema = (schema as yup.ArraySchema<any, any>)
        .min(rule.min, rule.minCustomMessage ?? undefined)
        .required(
          rule.minCustomMessage ??
            t(
              'rules.item-range.min',
              'Il campo ${label} deve contenere almeno {{min}} elementi',
              { min: rule.min },
            ),
        );
    }

    if (rule.max != null) {
      schema = (schema as yup.ArraySchema<any, any>).max(
        rule.max,
        rule.maxCustomMessage ?? undefined,
      );
    }

    return schema;
  },
};
